module.exports = __webpack_public_path__ + "img/card3.5ae039ec.svg";